<template>
      <router-view />


</template>

<script>


export default {
  name: 'App',
}
</script>

<style>
*{
  margin: 0;
}
.flex{
  display: flex;
}
.between{
  justify-content: space-between;
}
img {
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
.pointer{
  cursor: pointer;
}
.dialog2{
  margin: 1vh auto !important;
}
::-webkit-scrollbar{

width:8px;

height:8px;

background-color:#F5F5F5;

}

/*定义滚动条轨道

内阴影+圆角*/

::-webkit-scrollbar-track{

-webkit-box-shadow:inset 0 0 6px rgba(179, 172, 172, 0.3);

border-radius:10px;

background-color:#F5F5F5;

}

/*定义滑块

内阴影+圆角*/

::-webkit-scrollbar-thumb{

border-radius:10px;

-webkit-box-shadow:inset 0 0 6px rgba(134, 133, 133, 0.3);

background-color:rgb(189, 185, 185);

}

</style>
